module.exports = __webpack_public_path__ + "static/media/saint-laurent.4fa6245a.jpg";